const powerModes = {
  Eco: 'eco',
  Performance: 'performance',
}

export default powerModes
